export const featuredManhwa = [
  {
    id: 1,
    title: '剑与魔法',
    author: '金贤秀',
    category: '奇幻冒险',
    slug: 'sword-and-magic',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20warrior%20holding%20a%20glowing%20sword%20in%20a%20fantasy%20world%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20gold%20tones%2C%20anime%20webtoon%20cover%20art%20style%2C%20soft%20gradient%20background%2C%20clean%20composition&width=800&height=1120&seq=manhwa-cover-01&orientation=portrait',
    description: '在一个魔法与剑并存的奇幻世界，少年剑士踏上寻找传说之剑的冒险旅程，途中结识伙伴、对抗黑暗势力。',
    rating: 9.2,
    chapters: 156,
    views: 3280000,
    updateDate: '2026-07-02',
    tags: ['奇幻', '冒险', '热血'],
  },
  {
    id: 2,
    title: '甜蜜陷阱',
    author: '李恩静',
    category: '浪漫爱情',
    slug: 'sweet-trap',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20beautiful%20couple%20facing%20each%20other%20with%20cherry%20blossoms%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20romantic%20webtoon%20cover%20art%20style%2C%20dreamy%20atmosphere%2C%20clean%20minimal%20background&width=800&height=1120&seq=manhwa-cover-02&orientation=portrait',
    description: '高冷总裁与单纯女孩的意外邂逅，一段甜蜜又危险的办公室恋情悄然展开。当真心与算计交织，谁是猎手谁是猎物？',
    rating: 8.9,
    chapters: 98,
    views: 4560000,
    updateDate: '2026-07-01',
    tags: ['爱情', '都市', '甜宠'],
  },
  {
    id: 3,
    title: '暗夜追踪者',
    author: '朴志勋',
    category: '悬疑惊悚',
    slug: 'night-tracker',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20illustration%20of%20a%20detective%20in%20a%20dark%20alley%20at%20night%2C%20mysterious%20silhouette%20in%20background%2C%20film%20noir%20vibe%2C%20dark%20blue%20and%20deep%20red%20accents%2C%20webtoon%20cover%20art%20style%2C%20tense%20atmosphere&width=800&height=1120&seq=manhwa-cover-03&orientation=portrait',
    description: '连环杀手在城市中出没，天才侧写师与刑警联手追凶，却发现真相远比想象中更加黑暗。每一页都让人屏息。',
    rating: 9.5,
    chapters: 67,
    views: 2890000,
    updateDate: '2026-06-30',
    tags: ['悬疑', '犯罪', '推理'],
  },
  {
    id: 4,
    title: '重生之商业帝国',
    author: '崔明宇',
    category: '都市职场',
    slug: 'rebirth-business',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20illustration%20of%20a%20confident%20man%20in%20a%20modern%20office%20with%20city%20skyline%20through%20window%2C%20sleek%20professional%20style%2C%20warm%20neutral%20tones%20with%20gold%20highlights%2C%20webtoon%20cover%20art%20style&width=800&height=1120&seq=manhwa-cover-04&orientation=portrait',
    description: '前世被陷害含冤而死，重生回到二十年前，带着未来记忆的他在商界掀起惊涛骇浪，誓要改写命运。',
    rating: 9.0,
    chapters: 213,
    views: 5120000,
    updateDate: '2026-07-03',
    tags: ['重生', '商战', '爽文'],
  },
  {
    id: 5,
    title: '修仙模拟器',
    author: '韩智浩',
    category: '仙侠修真',
    slug: 'cultivation-simulator',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cultivation%20illustration%20of%20a%20young%20monk%20meditating%20with%20floating%20magical%20runes%20and%20lotus%20flowers%2C%20ethereal%20mist%2C%20jade%20green%20and%20gold%20color%20scheme%2C%20webtoon%20cover%20art%20style%2C%20serene%20atmosphere&width=800&height=1120&seq=manhwa-cover-05&orientation=portrait',
    description: '普通大学生意外获得修仙系统，在灵气复苏的时代一步步踏上仙途，却在修真界发现了惊天秘密。',
    rating: 8.7,
    chapters: 182,
    views: 3710000,
    updateDate: '2026-07-02',
    tags: ['修仙', '系统', '热血'],
  },
  {
    id: 6,
    title: '猫咪咖啡厅',
    author: '尹素英',
    category: '治愈日常',
    slug: 'cat-cafe',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20illustration%20of%20a%20cozy%20cat%20cafe%20with%20cute%20cats%20and%20a%20smiling%20barista%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20soft%20pastel%20colors%2C%20webtoon%20cover%20art%20style%2C%20healing%20atmosphere&width=800&height=1120&seq=manhwa-cover-06&orientation=portrait',
    description: '在城市角落的一间猫咪咖啡厅里，形形色色的客人与可爱的猫咪们，发生了一个又一个温暖治愈的小故事。',
    rating: 9.1,
    chapters: 45,
    views: 1980000,
    updateDate: '2026-06-29',
    tags: ['治愈', '日常', '萌宠'],
  },
];

export const categories = [
  { name: '浪漫爱情', slug: 'romance', icon: 'ri-heart-line', count: 1280, color: 'accent' },
  { name: '奇幻冒险', slug: 'fantasy', icon: 'ri-sword-line', count: 960, color: 'primary' },
  { name: '悬疑惊悚', slug: 'thriller', icon: 'ri-search-eye-line', count: 540, color: 'secondary' },
  { name: '都市职场', slug: 'urban', icon: 'ri-building-line', count: 720, color: 'primary' },
  { name: '仙侠修真', slug: 'cultivation', icon: 'ri-moon-line', count: 450, color: 'secondary' },
  { name: '治愈日常', slug: 'healing', icon: 'ri-cup-line', count: 380, color: 'accent' },
  { name: '武侠江湖', slug: 'martial-arts', icon: 'ri-shield-line', count: 620, color: 'primary' },
  { name: '科幻未来', slug: 'sci-fi', icon: 'ri-rocket-line', count: 310, color: 'secondary' },
];

export const articles = [
  ...featuredManhwa,
  { id: 7, title: '暴君的小娇妻', slug: 'tyrant-wife' },
  { id: 8, title: '魔法学院优等生', slug: 'magic-academy' },
  { id: 9, title: '职场女王', slug: 'office-queen' },
  { id: 10, title: '九尾狐传说', slug: 'nine-tailed-fox' },
  { id: 11, title: '末日求生指南', slug: 'apocalypse-survival' },
  { id: 12, title: '三生三世桃花开', slug: 'peach-blossom' },
];

export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20avatar%2C%20friendly%20smile%2C%20casual%20style%2C%20simple%20warm%20background%2C%20professional%20headshot%20style%2C%20clean%20and%20minimal&width=200&height=200&seq=avatar-user-01&orientation=squarish',
    comment: '虚空韩漫网的漫画资源太丰富了！我喜欢的韩漫这里全都有，而且更新速度超快，每天刷都有新章节。下拉式阅读体验真的太舒服了，一口气能看几十话！',
    rating: 5,
  },
  {
    id: 2,
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20avatar%2C%20warm%20smile%2C%20natural%20look%2C%20simple%20warm%20beige%20background%2C%20professional%20headshot%20style%2C%20clean%20composition&width=200&height=200&seq=avatar-user-02&orientation=squarish',
    comment: '对比了好几个漫画网站，虚空韩漫才是真免费！无删减内容看起来很完整，翻译质量也很高，强烈推荐给喜欢韩漫的小伙伴们。',
    rating: 5,
  },
  {
    id: 3,
    name: '深夜读者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20avatar%2C%20thoughtful%20expression%2C%20casual%20hoodie%2C%20simple%20warm%20gray%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-user-03&orientation=squarish',
    comment: '跨设备同步进度这个功能简直神器！白天在手机上看到一半，晚上回家用电脑接着看，进度完全同步，再也不用记看到哪了。',
    rating: 5,
  },
  {
    id: 4,
    name: '韩漫老粉',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20woman%20portrait%20avatar%2C%20confident%20expression%2C%20modern%20style%2C%20simple%20warm%20cream%20background%2C%20professional%20headshot%20style%2C%20clean%20and%20polished&width=200&height=200&seq=avatar-user-04&orientation=squarish',
    comment: '追韩漫三年了，虚空韩漫网是我用过最好的平台。分类清晰，推荐精准，而且界面设计简洁好看，没有任何乱七八糟的广告。',
    rating: 5,
  },
  {
    id: 5,
    name: '上班摸鱼达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20avatar%2C%20slight%20smile%2C%20casual%20office%20look%2C%20simple%20warm%20background%2C%20professional%20headshot%20style%2C%20approachable&width=200&height=200&seq=avatar-user-05&orientation=squarish',
    comment: '午休时间刷几话韩漫已经成为我的日常了。虚空韩漫加载速度很快，下拉式阅读超流畅，午休半小时刚好能看两三话，完美！',
    rating: 5,
  },
  {
    id: 6,
    name: '漫画收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20woman%20portrait%20avatar%2C%20warm%20smile%2C%20casual%20elegant%20style%2C%20simple%20warm%20beige%20background%2C%20professional%20headshot%20style%2C%20minimal%20composition&width=200&height=200&seq=avatar-user-06&orientation=squarish',
    comment: '收藏了很多韩漫，虚空韩漫的分类功能特别好用，按类型找漫画一目了然。而且每周都有新作品上架，永远不愁没得看。',
    rating: 5,
  },
];

export const stats = {
  totalUsers: 2860000,
  totalWorks: 15800,
  dailyVisits: 520000,
  weeklyUpdates: 3200,
};

export const aboutContent = {
  brandName: '虚空韩漫网',
  brandIntro: '虚空韩漫网成立于2022年，是国内领先的韩国漫画在线阅读平台。我们致力于为广大韩漫爱好者提供最全面、最及时、最高质量的韩漫阅读服务。平台收录超过15,800部韩漫作品，涵盖浪漫爱情、奇幻冒险、悬疑惊悚、都市职场、仙侠修真等多个热门分类。',
  vision: '我们的愿景是打造中文世界最好的韩漫阅读社区，让每一位读者都能在这里找到心仪的作品，享受纯粹而愉悦的阅读体验。',
  mission: '连接读者与优质韩漫，无缝相遇，随心阅读。',
  contact: {
    email: 'hello@jiukuguoji.com',
    address: '中国上海市浦东新区张江高科技园区',
    phone: '021-5888-6666',
  },
  milestones: [
    { year: '2022', event: '虚空韩漫网正式上线，收录韩漫作品2,000部' },
    { year: '2023', event: '平台用户突破100万，推出跨设备同步功能' },
    { year: '2024', event: '收录作品突破10,000部，上线智能推荐系统' },
    { year: '2025', event: '用户突破200万，成为国内前三韩漫阅读平台' },
    { year: '2026', event: '持续优化阅读体验，平台全面升级改版' },
  ],
};
